/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPLAY_OBJ_CLAIM = 'GET_CURRENT_DISPLAY_OBJ_CLAIM';
export const GET_PLAN_TYPE_DATA_CLAIM = 'GET_PLAN_TYPE_DATA_CLAIM';
export const GET_REBATE_PROGRAM_CLAIM = 'GET_REBATE_PROGRAM_CLAIM';
export const GET_REBATE_PROGRAM_NAME_CLAIM = 'GET_REBATE_PROGRAM_NAME_CLAIM';
export const GET_ERROR_MSG_CLAIM = 'GET_ERROR_MSG_CLAIM';
export const GET_FROM_CLAIM = 'GET_FROM_CLAIM';
export const SET_REFRESH_DATA_CLAIM = 'SET_REFRESH_DATA_CLAIM';
export const SET_DISPLAY_DATA_CLAIM = 'SET_DISPLAY_DATA_CLAIM';

export const SET_PROVIDER_SELECTION_CLAIM = 'SET_PROVIDER_SELECTION_CLAIM';
export const SET_PROVIDER_REFERENCE_CLAIM = 'SET_PROVIDER_REFERENCE_CLAIM';
export const SET_PROVIDER_LIST_CLAIM = 'SET_PROVIDER_LIST_CLAIM';
export const SET_PROVIDER_DATA_CLAIM = 'SET_PROVIDER_DATA_CLAIM';
export const SET_PROVIDER_GRID_DATA_CLAIM = 'SET_PROVIDER_GRID_DATA_CLAIM';
export const SET_DISPLAY_OBJ_CLAIM = 'SET_DISPLAY_OBJ_CLAIM';
export const SET_PAGINATION_INDEX_PROVIDER_CLAIM_LISTING =
  'SET_PAGINATION_INDEX_PROVIDER_CLAIM_LISTING';
